import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Group, GroupApiResponse} from "features/model/types/groups/groupsSchema";


interface ErrorState {
    status: number;
}

const errorSlice = createSlice({
    name: "error",
    initialState: {
        status:200,
    } as ErrorState,
    reducers: {
        setNotFoundError: (state, action: PayloadAction<number>) => {
            state.status = action.payload
        },
    },
});

export const { setNotFoundError } = errorSlice.actions;
export const errorReducer = errorSlice.reducer;
